
(function loginControllerDefinition() {

    'use strict';

    angular.module('Login')
        .controller('LoginFormController', [
            '$http', '$scope', 'auth', '$timeout', 'onMobile', '$state', '$translate', 'alerts', 'login', 'messages','config',
            function (http, $scope, auth, $timeout, mobile, $state, $translate, alerts, login, messages, config) {
                $scope.requiredOtp = false;
                $scope.$on('clearLogin', function() {
                    $scope.userInfo = {};
                });

                if ($scope.useRegister === undefined) {
                    $scope.useRegister = true;
                }

                $scope.userInfo = {};

                $scope.imagesUrl = login.imagesUrl;

                $scope.loginResult = function (result) {
                    
                    if (!angular.isUndefined(result)) {
                        var resOnLogin = $scope.onLogin({ result: result || false });

                        if (resOnLogin !== false)
                            login.redirect(result);
                    }

                    if (result)
                        $scope.userInfo = {};
                };

                $scope.register = function loginControllerRegister() {
                    auth.resetExternalInfo();
                    $scope.loginResult({
                        action: 'register'
                    });
                };

                $scope.back = function () {
                    $scope.requiredOtp = false;
                    $scope.$on('clearLogin', function () {
                        $scope.userInfo = {};
                    });

                    if ($scope.useRegister === undefined) {
                        $scope.useRegister = true;
                    }
                    $scope.userInfo = {};
                    $scope.imagesUrl = login.imagesUrl;
                };

                $scope.loginOtp = function (userInfo, windows) {
                    $scope.login(userInfo, windows);
                }

                $scope.login = function loginControllerLogin(userInfo, windows) {

                    if (userInfo || windows) {
                        var user, pass, remember, otp;

                        if (userInfo) {
                            user = userInfo.userName;
                            pass = userInfo.password;
                            remember = userInfo.rememberMe;
                            otp = userInfo.otp;
                        }

                        auth.login(user, pass, remember, null, otp)
                            .then(function(result) {

                                    $scope.disabled = null;
                                    $scope.error = !result;
                                    $scope.lockoutTime = null;
									$scope.isLockedOutSelfManagement = null;
                                    $scope.lockedInNextAttempt = false;
                                    $scope.requiredOtp = false;

                                    if (result) {
                                        $scope.loginResult(true);
                                    }
                                },
                                function(error) {
                                    $scope.disabled = null;
                                    $scope.error = false;
                                    $scope.lockoutTime = null;
									$scope.isLockedOutSelfManagement = null;
                                    $scope.lockedInNextAttempt = false;

                                    if (error.disabled) {
                                        $scope.disabled = true;
                                    } else if (error.isLockedOut) {
                                        $scope.lockoutTime = error.lockoutTime;
                                    } else if (error.lockedInNextAttempt) {
                                        $scope.lockedInNextAttempt = error.lockedInNextAttempt;
                                    } else if (error.isLockedOutSelfManagement) {
                                        $scope.isLockedOutSelfManagement = true;
                                    } else if (error.error === 'pendingOtpKey') {
                                        $scope.requiredOtp = true;
                                    } else if (error.error === 'InvalidOTP') {
                                        messages.show(error.error_description);
                                    } else if (error.notConfirmed) {

                                        $scope.loginResult({
                                            action: 'confirm',
                                            userId: error.userId
                                        });
                                    } else {

                                        if (error.ldap) {
                                            var params = {
                                                userName: user,
                                                password: pass
                                            }

                                            $state.go('user-add-new', params);
                                        }

                                        $scope.error = true;
                                    }

                                });
                    } else {
                        // El refresh lo hace la página por el client id
                        auth.refreshToken()
                            .then(function(result) {
                                    if (!result) {
                                        messages.show('RefreshError');
                                        return;
                                    } else {
                                        $scope.loginResult(true);
                                    }
                                },
                                function() {
                                    messages.show('RefreshError');
                                });
                    }
                };

                $scope.forgot = function () {
                    if ($scope.userInfo.userName) {
                        auth.forgotPassword($scope.userInfo.userName, login.changePasswordCallbackUrl, login.applicationId)
                            .then(function() {
                                    $translate(['ForgotPassOKTitle', 'ForgotPassOk', 'ErrorOk'])
                                        .then(function(translated) {
                                            alerts.alert(translated.ForgotPassOKTitle,
                                                translated.ForgotPassOk,
                                                translated.ErrorOk);
                                        });
                                },
                                function() {
                                    messages.show('ForgotPassError');
                                });
                    } else {
                        messages.show('ForgotPassEnterUserName');
                    }
                };

                $scope.generateOtp = function () {
                    var params = {
                        appId: config.appId(),
                        callbackUrl: config.custom('arandanoUrl') + "/#/otp-code/{0}",
                        userName: $scope.userInfo.userName
                    };

                    auth.generateOtp(params).then(function (result) {
                        messages.showSuccess('GenerateOtpMessage');
                    })
                };

                $scope.providers = [];

                if ($scope.disableExternalLogin !== true) {
                    auth.getExternalProviders(login.getExternalProvidersUrl())
                        .then(function (providers) {
                            $scope.providers = providers;
                        });
                }

                $scope.loginWith = function(provider) {

                    login.loginWithProvider(provider)
                        .then(function loginWithProviderResult() {
                                $scope.loginResult(true);
                            },
                            function loginWithProviderError(error) {

                                if (error.key === 'user_not_confirmed') {
                                    $state.go('confirm-mail', {
                                        code: error.message,
                                        resend: true
                                    });
                                } else {
                                    messages.show('LoginFormExternalError');
                                }

                                $scope.loginResult(false);
                            });
                };
            }
        ]);

})();